import { useTranslation } from 'react-i18next'

import { AIButtonContainedGrey } from '../../AIButton'
import { BUTTON_HEIGHT_40 } from '../../Button'
import { ICON_HEIGHT_16 } from '../../Icon'
import { QA_NAME_GRETA_AI_CHAT_SUGGESTED_PROMPT } from '../GretaAIChat.constants'

import { PROMPT_ICON } from './GretaAIChatSuggestedPrompt.constants'

import * as styles from './GretaAIChatSuggestedPrompt.module.css'

function GretaAIChatSuggestedPrompt({
  disabled = false,
  prompt,
  onSelectPrompt,
  onSendPrompt,
}) {
  const { t } = useTranslation()

  const promptText = t(prompt.textKey)

  function handleClick() {
    if (prompt.isTemplate) {
      onSelectPrompt(`${promptText} `)
    } else {
      onSendPrompt(promptText)
    }
  }

  return (
    <AIButtonContainedGrey
      beforeIconProps={{ Icon: PROMPT_ICON[prompt.id], height: ICON_HEIGHT_16 }}
      className={styles.prompt}
      disabled={disabled}
      height={BUTTON_HEIGHT_40}
      qaName={QA_NAME_GRETA_AI_CHAT_SUGGESTED_PROMPT}
      text={promptText}
      textClassName={styles.promptLabel}
      onClick={handleClick}
    />
  )
}

export default GretaAIChatSuggestedPrompt
